import React from 'react';
import { Container } from '@material-ui/core';
import Page from 'src/components/Page';
import { AttendanceTable } from './attendance-table';
import { useAuthContext } from 'src/context/AuthContext';

export const AttendanceManagementScreen = ()=>{
  const { user } = useAuthContext();

  return (
    <Page title="Attendance Management">
      <Container>
        {!isNaN(user.group)&&<AttendanceTable group={user.group}/>}
      </Container>
    </Page>
  );
};